import React, { createContext, useContext, useState } from 'react';

const ApplicationFormContext = createContext();

export const ApplicationFormProvider = ({ children }) => {
  const [isApplicationFormOpen, setIsApplicationFormOpen] = useState(false);

  const openApplicationForm = () => {
    setIsApplicationFormOpen(true);
  };

  const closeApplicationForm = () => {
    setIsApplicationFormOpen(false);
  };

  return (
    <ApplicationFormContext.Provider 
      value={{ 
        isApplicationFormOpen, 
        openApplicationForm, 
        closeApplicationForm 
      }}
    >
      {children}
    </ApplicationFormContext.Provider>
  );
};

export const useApplicationForm = () => {
  const context = useContext(ApplicationFormContext);
  if (!context) {
    throw new Error('useApplicationForm must be used within ApplicationFormProvider');
  }
  return context;
};

